if (!customElements.get("section-multiple")) {
    customElements.define(
        "section-multiple",
        class SectionMultiple extends HTMLElement {
            constructor() {
                super();
                this.init();
            }
            init() {
                const flexItems = this.querySelectorAll(".section-multiple-flex");
                const cuItems = this.querySelectorAll(".pagination-cu-item");
                this.itemHover(flexItems, cuItems);
                this.itemHover(cuItems, flexItems);
            }
            itemHover(items1, items2) {
                $(items1).hover(
                    function () {
                        let activeItem = items2[this.dataset.index];
                        $(items1).not(this).removeClass("active");
                        $(this).addClass("active");

                        $(items2).not(activeItem).removeClass("active");
                        $(activeItem).addClass("active");
                    },
                    function () {
                        let activeItem = items2[this.dataset.index];
                        $(items1).not(this).removeClass("active");
                        $(items2).not(activeItem).removeClass("active");
                    }
                );
            }
        }
    );
}
